import React, { useState, useEffect } from 'react';
import { settings } from '../lib/api';

const Logo = ({ size = 'md', className = '' }) => {
  const [academyName, setAcademyName] = useState('Pi German Academy');

  useEffect(() => {
    loadAcademyName();
  }, []);

  const loadAcademyName = async () => {
    try {
      const response = await settings.getAcademySettings();
      setAcademyName(response.data.academy_name);
    } catch (error) {
      console.log('Using default academy name');
    }
  };

  const sizes = {
    sm: { container: 'h-[135px]', image: 'h-[135px]', text: 'text-[36px]' },
    md: { container: 'h-[210px]', image: 'h-[210px]', text: 'text-[43px]' },
    lg: { container: 'h-[300px]', image: 'h-[300px]', text: 'text-[60px]' }
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center gap-0 ${className}`} data-testid="logo">
      <div className={`relative ${currentSize.container} aspect-square`}>
        <img
          src="https://customer-assets.emergentagent.com/job_elephant-deutsch/artifacts/fvorixsg_SGI%20INSTITUTE-01.png"
          alt="SGI Logo"
          className={`${currentSize.image} w-auto object-contain`}
        />
      </div>
      <div>
        <h1 className={`font-bold tracking-tight text-gray-900 ${currentSize.text}`}>
          {academyName}
        </h1>
      </div>
    </div>
  );
};

export default Logo;
